import styled from 'styled-components'

import { Layout } from '@loadsmart/miranda-react'

/** One column, left-aligned, at a width a headline and a sentence read well in. */
export const StyledColumn = styled(Layout.Stack)`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`

export const StyledHeadline = styled.h1`
  margin: 0;
  max-width: 24ch;
  font-family: var(--m-font-family-title);
  font-size: var(--m-font-size-8);
  font-weight: var(--m-font-weight-bold);
  line-height: 112%;
  letter-spacing: -0.02em;
  color: rgb(var(--m-color-primary-100));

  @media screen and (max-width: 720px) {
    font-size: var(--m-font-size-7);
  }
`

export const StyledLede = styled.p`
  margin: 0;
  max-width: 60ch;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-4);
  line-height: 160%;
  color: rgb(var(--m-color-text-tertiary));
`

/**
 * The one exchange on the page. It is what the Assistant does, shown rather
 * than described: a question, then an answer with the rows behind it.
 */
export const StyledExample = styled.figure`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-4);
  margin: 0;
  padding: var(--m-spacing-5);
  background-color: rgb(var(--m-color-background-primary));
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  border-radius: var(--m-border-radius-m);
`

export const StyledQuestion = styled.p`
  align-self: flex-end;
  margin: 0;
  max-width: 85%;
  padding: var(--m-spacing-2) var(--m-spacing-4);
  border-radius: var(--m-border-radius-m);
  background-color: rgb(var(--m-color-background-highlight));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  line-height: var(--m-line-height-5);
  color: rgb(var(--m-color-primary-100));
`

export const StyledAnswer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-3);
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  line-height: var(--m-line-height-5);
  color: rgb(var(--m-color-primary-100));

  p {
    margin: 0;
  }
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: var(--m-font-size-3);

  th,
  td {
    padding: var(--m-spacing-2) var(--m-spacing-3);
    border-bottom: var(--m-border-thin) solid rgb(var(--m-color-border));
    text-align: left;
  }

  th {
    font-weight: var(--m-font-weight-medium);
    color: rgb(var(--m-color-text-tertiary));
  }

  /* Figures line up on the digit, so a column of counts can be compared. */
  th:not(:first-child),
  td:not(:first-child) {
    text-align: right;
    font-variant-numeric: tabular-nums;
  }
`

export const StyledCaption = styled.figcaption`
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-2);
  line-height: var(--m-line-height-5);
  color: rgb(var(--m-color-text-placeholder));
`

export const StyledActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--m-spacing-4);
`

export const StyledAside = styled.p`
  margin: 0;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  color: rgb(var(--m-color-text-tertiary));
`
